<div class="slider">
  <div class="image-container">
    <div
      *ngFor="let slide of slides"
      class="slide"
      [ngStyle]="{ transform: 'translateX(-' + currentIndex * 100 + '%)' }"
    >
      <img class="img" src="{{ slide.url }}" alt="" />

      <span class="title">{{ slide.title }}</span>
      <span class="subtitle">{{ slide.subtitle }}</span>
    </div>
  </div>

  <div class="dotsContainer">
    <div
      *ngFor="let slide of slides; let slideIndex = index"
      class="bar"
      [ngStyle]="{
        'background-color': slideIndex === currentIndex ? '#000000' : '#D8DADB'
      }"
      (click)="goToSlide(slideIndex)"
    ></div>
  </div>
</div>
